import { Dialog, DialogActions, DialogContent, DialogContentText, Button, Box, Divider, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { DeletIcon } from '../../assets';
const DeleteDialogBox = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent>
        <Box sx={{ textAlign: "center", mb: 2 }}>
          <Box sx={{ mt: 3 }} component="img" src={DeletIcon} />
        </Box>
        <DialogContentText sx={{ textAlign: "center", mb: 3 }}>
          <Typography sx={{ fontSize: "18px" }}>
            {" "}
            Are you sure you want to delete this API key ?
          </Typography>
        </DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ justifyContent: "flex-end" }}>
        <Button
          onClick={onClose}
          sx={{
            border: "solid 1px #03A9F4",
            textTransform: "none",
            fontSize: "14px",
            borderRadius: 2,
            px: 1.5,
            py: 1,
            color: "#03A9F4",
          }}
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            border: "solid 1px #E53935",
            textTransform: "none",
            fontSize: "14px",
            borderRadius: 2,
            px: 1.5,
            py: 1,
            backgroundColor: "#E53935",
            "&:hover": {
              backgroundColor: "#E53935",
              borderColor: "#E53935",
            },
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteDialogBox.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default DeleteDialogBox;
